module.exports = __webpack_public_path__ + "img/discord.5ae4b594.svg";